import api from "./api";
import indicationService from "./indication";

// Informes en PDF que llegan por HL7. Están en su propia colección (no son
// indicaciones) y se ven solo desde el botón "Informes" de la ficha.
const patientReportService = {};
const endpoint = "/patient-reports";

patientReportService.list = function (patientId) {
  return api.get(endpoint, { params: { patientId } }).then(({ data }) => data);
};

// Las URLs son firmadas y vencen a los pocos minutos: se piden en el momento
// del click, nunca se guardan.
patientReportService.getViewUrl = function (reportId) {
  return api.get(`${endpoint}/${reportId}/view`).then(({ data }) => data.url);
};

patientReportService.getDownloadUrl = function (reportId) {
  return api
    .get(`${endpoint}/${reportId}/download`)
    .then(({ data }) => data.url);
};

// Para decidir si mostrar el botón "Informes": alcanza con que haya informes
// de texto (indicaciones imagesResults) o en PDF.
export async function hasPatientReports(patientId) {
  const [textReports, pdfReports] = await Promise.all([
    indicationService
      .get(patientId, [{ type: "imagesResults" }])
      .catch(() => []),
    patientReportService.list(patientId).catch(() => []),
  ]);
  return textReports.length > 0 || pdfReports.length > 0;
}

export default patientReportService;
